<template>
    <collapsible-card :title="'Vessels Visited in the Last 30 Days'" v-show="showVessels" ref="cCard">
        <div class="cardContent">
            <table class="staticTable">
                <thead>
                    <tr>
                        <th scope="col">Vessels</th>
                        <th scope="col">Provider</th>
                    </tr>
                </thead>
                <tbody>
                   <tr v-for="obj in vessels" :key="obj.mmsi">
                       <td data-label="Vessel"><p class="vesselIdentify"><router-link :to="{name: 'Vessels', params: { mmsi: obj.mmsi }}" class="link">{{obj.mmsi}}</router-link> {{obj.name}}</p></td>
                       <td data-label="Provider">
                           <router-link :to="{name: 'Providers', params: { provider: obj.provider }}" class="link"> {{obj.provider}} </router-link>
                       </td>
                   </tr>
                </tbody>
            </table>
        </div>
    </collapsible-card>
</template>

<script>
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'op-vessels',
    components: {
        CollapsibleCard
    },
    data: () => ({
        showVessels: false,
        vessels: []
    }),
    methods: {
        updateInfo: function(vesselInfo) {
            var globv = this;
            globv.vessels = vesselInfo;

            globv.showVessels = globv.vessels.length > 0;

            globv.$refs.cCard.adjustHeight();
        },
        reset: function() {
            var globv = this;
            globv.showVessels = false;
            globv.vessels = [];
        }
    }
}
</script>